<template>
  <section>
    <span data-test="infotext" v-html="$tc('cita.infotext2', msisdn)" />
    <VProgress class="offset-top-2 offset-bottom-2" :steps="steps" active="cita.youridentcode" />
    <span>{{ $t('cita.identtext2') }}</span>

    <VForm v-if="form" :form="form" @submit="onNext">
      <VInput name="otp" :label="$t('cita.youridentcode')" :hint="$t('errorcodes.WRONG_OTP')" :placeholder="$t('cita.inputcode')" required />
      <div class="offset-top-2 text-right">
        <transition name="fade" mode="out-in" appear>
          <VSpinner v-if="isBusy" slim class="pull-left" />
        </transition>
        <VButton
          type="button"
          class="offset-left-1 offset-bottom-1 btn-default"
          label="cita.label_request_new_code"
          :disabled="isBusy || isOtpResendDisabled"
          @click="onResendOtp"
        />

        <transition name="fade" mode="out-in" appear>
          <div v-if="isOtpResendDisabled" class="notification notification-negative" role="alert">
            <div class="notification-left">
              <div class="icon-frame">
                <VSvgIcon name="information" variant="outlined" size="large" />
              </div>
            </div>
            <div class="notification-content">
              <div class="notification-heading offset-top-1">
                {{ $t('errorcodes.OTP_RESEND_LIMIT_EXCEEDED') }}
              </div>
            </div>
          </div>
        </transition>

        <hr />

        <VButton tag="a" class="offset-left-1 offset-bottom-1 btn btn-default" label="cita.abort" @click.prevent="onAbort" />
        <VButton tag="a" class="offset-left-1 offset-bottom-1 btn btn-default" label="cita.change_MSISDN" @click.prevent="onChangeMsisdn" />
        <VButton type="submit" class="offset-left-1 offset-bottom-1 btn btn-default btn-brand" label="cita.continue" :disabled="isBusy" />
      </div>
    </VForm>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TitleMixin from '@/mixins/title';
import CitaStepsMixin from '@/mixins/citaSteps';
import OtpResendMixin from '@/mixins/otpResend';
import VSpinner from '@/components/Spinner';
import VForm from '@/components/Form/Form';
import VInput from '@/components/Form/Input';
import Proxy from '@/proxies/CitaProxy';
import { safeNavigate } from '@/utils/safeUrl';
import { focusFirstError, initFields } from '@/utils/form';
import { CITA_CONFIRM, CITA_IDENTIFY } from '@/router/route-types';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'CitaAuth',

  components: {
    VSvgIcon,
    VForm,
    VInput,
    VSpinner,
    VProgress: () => import('@/components/Progress'),
    VButton: () => import('@/components/Button'),
  },

  mixins: [TitleMixin, CitaStepsMixin, OtpResendMixin],

  data() {
    return {
      CITA_IDENTIFY,
      form: initFields({ name: 'otp' }),
      isBusy: false,
      proxy: new Proxy(),
    };
  },

  computed: {
    ...mapState('cita', ['msisdn', 'refUrl']),
    ...mapGetters('cita', ['getPageTypeWebtrekk']),
  },

  created() {
    this.$webtrekk.viewPage(`cita.${this.getPageTypeWebtrekk}.identifikationscode`);
  },

  methods: {
    async onAbort() {
      await this.$webtrekk.link('cita.abort', this.refUrl);
      // SECURITY: safeNavigate refuses non-http(s) URLs (blocks javascript:/data: XSS).
      safeNavigate(this.refUrl);
    },

    onChangeMsisdn() {
      this.$router.push({ name: CITA_IDENTIFY });
      this.$webtrekk.link('cita.change_MSISDN', CITA_IDENTIFY);
    },

    async onNext({ values, form }) {
      try {
        this.isBusy = true;
        const response = await this.proxy.otpVerify(values.otp);
        this.$store.dispatch('system/setWholesalePartnerId', response.wholesalePartnerId);
        this.$store.dispatch('system/setHasLogo', response.hasLogo);
        this.$store.dispatch('cita/setAuthenticated');
        this.$store.dispatch('cita/setPrice', response.price);
        this.$store.dispatch('cita/setCaptcha', response.captcha);
        this.$router.replace({ name: CITA_CONFIRM });
        this.$webtrekk.link('cita.continue', CITA_CONFIRM);
      } catch (error) {
        const code = error?.data?.code;
        if (code === 'WRONG_OTP') {
          form.otp.setInvalid();
        } else {
          throw error;
        }
        focusFirstError(form);
        this.isBusy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
</style>
